import { FC } from "react";
import { OutboundModal } from "./OutboundModal";
import { EmptyGaylordCodeModal } from "./EmptyGaylordCode";
import { InvalidGaylordCodeModal } from "./InvalidGaylordCode";
import { UnrecognizedTrackingCodeModal } from "./UnrecognizedTrackingCode";
import { IncorrectAssignmentModal } from "./IncorrectAssignment";
import { ShippingLabelConfirmation } from "./ShippingLabelConfirmation";
import { GaylordTypeConfirmation } from "sortation/pages/Outbound/modals/GaylordTypeConfirmation";
import { OutboundErrorModal, OutboundErrorModalProps } from "./OutboundErrorModal";

export const outboundModalMap: Record<OutboundModal, FC<any>> = {
  [OutboundModal.EMPTY_GAYLORD_CODE]: EmptyGaylordCodeModal,
  [OutboundModal.INVALID_GAYLORD_CODE]: InvalidGaylordCodeModal,
  [OutboundModal.UNRECOGNIZED_TRACKING_CODE]: UnrecognizedTrackingCodeModal,
  [OutboundModal.INCORRECT_ASSIGNMENT]: IncorrectAssignmentModal,
  [OutboundModal.REPRINT_SHIPPING_LABEL_CONFIRMATION]: ShippingLabelConfirmation,
  [OutboundModal.GAYLORD_TYPE_CONFIRMATION]: GaylordTypeConfirmation,
  [OutboundModal.INVALID_GAYLORD_TYPE_FOR_QUINCE_AIR]: OutboundErrorModal,
  [OutboundModal.INVALID_GAYLORD_TYPE_FOR_QUINCE_GROUND]: OutboundErrorModal,
  [OutboundModal.GAYLORD_STAGED_NO_MORE_PACKAGE_ASSIGNMENT]: OutboundErrorModal,
  [OutboundModal.INVALID_PACKAGE_TYPE_FOR_MASTER_CARTON]: OutboundErrorModal,
  [OutboundModal.MASTER_CARTON_ALREADY_ASSIGNED_TO_PALLET]: OutboundErrorModal,
  [OutboundModal.ACTIVE_MAPPING_NOT_FOUND]: OutboundErrorModal,
};

export const outboundErrorMessageMap: Partial<Record<OutboundModal, OutboundErrorModalProps>> = {
  [OutboundModal.INVALID_GAYLORD_TYPE_FOR_QUINCE_AIR]: {
    title: "Wrong gaylord type",
    text: "Quince AIR packages must be assigned to a master carton or Quince pallet. Scan a different gaylord.",
    hideModalValue: OutboundModal.INVALID_GAYLORD_TYPE_FOR_QUINCE_AIR,
  },
  [OutboundModal.INVALID_GAYLORD_TYPE_FOR_QUINCE_GROUND]: {
    title: "Wrong gaylord type",
    text: "Quince GROUND packages cannot be assigned to a master carton. Scan a different gaylord.",
    hideModalValue: OutboundModal.INVALID_GAYLORD_TYPE_FOR_QUINCE_GROUND,
  },
  [OutboundModal.GAYLORD_STAGED_NO_MORE_PACKAGE_ASSIGNMENT]: {
    title: "Gaylord already staged",
    text: "This gaylord has been staged and cannot accept more packages. Scan a different gaylord.",
    hideModalValue: OutboundModal.GAYLORD_STAGED_NO_MORE_PACKAGE_ASSIGNMENT,
  },
  [OutboundModal.INVALID_PACKAGE_TYPE_FOR_MASTER_CARTON]: {
    title: "Invalid package type",
    text: "This package cannot be assigned to a master carton. Return it to the sort queue.",
    hideModalValue: OutboundModal.INVALID_PACKAGE_TYPE_FOR_MASTER_CARTON,
  },
  [OutboundModal.MASTER_CARTON_ALREADY_ASSIGNED_TO_PALLET]: {
    title: "Master carton already assigned",
    text: "This master carton is already assigned to a pallet. Scan a different master carton.",
    hideModalValue: OutboundModal.MASTER_CARTON_ALREADY_ASSIGNED_TO_PALLET,
  },
  [OutboundModal.ACTIVE_MAPPING_NOT_FOUND]: {
    title: "Sort code mapping missing",
    text: "No active sort code mapping found for this package. Contact a supervisor.",
    hideModalValue: OutboundModal.ACTIVE_MAPPING_NOT_FOUND,
  },
};
